/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import moment from 'moment';

import cleanUpResponse from '../util/cleanUpResponse';
import getUserIdFromDn from '../util/getUserIdFromDn';

export default async function GetTaskData(taskId) {
  const response = await $.soap({
    body: {
      GetTaskData: {
        $xmlns: 'http://TODO-URL/ems/common/task/bpm/1.0',
        TaskID: taskId
      }
    },
    blueprintArrays: ['GetTaskDataResponse.Task.Targets.Target'],
    blueprint: {
      taskId: '$..Task.TaskId',
      processInstanceId: '$..ProcessInstanceId',
      possibleActions: '$..PossibleActions',
      state: '$..State',
      activity: '$..Activity',
      assigneeDn: '$..Assignee.__text',
      assigneeName: '$..Assignee.$displayName',
      completedByDn: '$..CompletedByUser.__text',
      completedByName: '$..CompletedByUser.$displayName',
      deliveryDate: '$..DeliveryDate',
      startDate: '$..StartDate',
      completionDate: '$..CompletionDate',
      rawTaskData: '$..Task.TaskData.ApplicationData.forminputdata.EMCEETaskModel.Task',
      targets: [
        '$..Target',
        {
          type: '$type',
          targetDn: '$.__text'
        }
      ],
      taskType: {
        id: '$.GetTaskDataResponse.TaskType.ID',
        name: '$.GetTaskDataResponse.TaskType.Name',
        description: '$.GetTaskDataResponse.TaskType.Description',
        formIdentifier: '$.GetTaskDataResponse.TaskType.FormIdentifier'
      }
    }
  });

  cleanUpResponse(response);

  const taskData = {};
  const claimedDate = _.get(taskData, 'ClaimedDate');
  if (claimedDate) {
    response.claimedDate = moment(claimedDate, moment.ISO_8601);
  }
  response.taskData = response.rawTaskData;
  response.assignee = getUserIdFromDn(response.assigneeDn);
  response.completedBy = getUserIdFromDn(response.completedByDn);
  response.isCreated = response.state === 'CREATED';
  response.isAssigned = response.state === 'ASSIGNED';
  response.isCompleted = response.state === 'COMPLETED';
  response.isObsolete = response.state === 'OBSOLETE' || response.state === 'SUSPENDED';
  response.completionDate = moment.utc(response.completionDate, moment.ISO_8601).local();
  response.deliveryDate = moment.utc(response.deliveryDate, moment.ISO_8601).local();
  response.startDate = moment.utc(response.startDate, moment.ISO_8601).local();
  return response;
}
